import { Injectable } from '@angular/core'

import { Observable, of } from 'rxjs'
import { UserServiceResources as us } from 'se-resource-types'
import { EditPersonaModalSubmitter } from '../../lib/edit-persona-modal/edit-persona-modal-submit.service'

@Injectable({
  providedIn: 'root'
})
export class DocsEditPersonaModalSubmitter extends EditPersonaModalSubmitter {
  constructor() {
    super()
  }

  public submit(formValue: any, persona: us.Persona): Observable<us.Persona> {
    const payload = this.createPayload(formValue, persona)
    console.log('submit', payload)
    return of({ ...persona, ...payload } as us.Persona)
  }
}
